// extracted by mini-css-extract-plugin
module.exports = {"row":"styles__row--2TBRe","pass":"styles__pass--2TgJo","fail":"styles__fail--Bed6Y"};